import {ProxyContainer} from '../Data/Data';
import {StorageService} from './StorageService';

export class EmployeeDataService {

  static $inject = ['$proxy', StorageService.serviceId];
  static serviceId = 'EmployeeDataService';
  static updateInterval = 60 * 60 * 1000;

  constructor(private $proxy: ProxyContainer, private storage: StorageService) {


  }

  public async loadByExternalId(externalId: number) {

    try {
      const employees = await this.loadEmployees();

      return employees.filter(es => es.externalId === externalId)[0];
    }
    catch (err) {
      console.log(err);
    }

  }

  private async loadEmployees() {
    const stamp = this.storage.getLasEmployeeUpdate();

    if(!stamp) {
      return await this.refreshEmployees();
    }

    if(stamp < new Date().getTime() - EmployeeDataService.updateInterval) {
      // dont await reloaded employees just refresh the cache in background
      this.refreshEmployees();
    }

    return this.storage.getEmployees();

  }

  private async refreshEmployees() {
    try {
      const es =  await this.$proxy.Employee.getProjectEmployeesMultiple({});
      this.storage.setEmployees(es.data);
      return es.data;
    }
    catch (err) {
      console.log(err);
    }
  }
}